<template>
    <card title="Bulk External Transfer">
        <BulkTransferOutComponent
            :show-filters="true"
            @transfer-completed="onTransferCompleted" />
    </card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import BulkTransferOutComponent from '@/components/Transfer/BulkTransferOutComponent.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: 'BulkTransferOutPage',
    components: {
        BulkTransferOutComponent
    },
    metaInfo: {
        title: 'Bulk External Transfer'
    }
})
export default class BulkTransferOutPage extends Vue {
    onTransferCompleted(result: any) {
        // The modal already reported which prescriptions failed; a blanket success on top of that would
        // contradict it.
        if (result?.partialFailure) return;

        const count = result?.transferredCount || result?.length || 1;
        const prescriptionText = count === 1 ? 'Prescription has' : 'Prescriptions have';
        this.$notification(NotificationOptions.success(`${prescriptionText} been successfully transferred.`));
        console.log('Transfer completed:', result);
    }
}
</script>